import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function BarsGraphIcon(props) {
    return (
        <SvgIcon style={{"fontSize": props.fontSize}}>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 180.000000 180.000000"
                 preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)"
                   fill={props.color} stroke="none">
                    <path d="M500 905 l0 -475 400 0 c349 0 400 2 400 15 0 13 -49 15 -385 15
l-385 0 0 460 c0 402 -2 460 -15 460 -13 0 -15 -59 -15 -475z"/>
                    <path d="M1170 875 l0 -335 30 0 30 0 0 335 0 335 -30 0 -30 0 0 -335z"/>
                    <path d="M780 805 l0 -265 30 0 30 0 0 265 0 265 -30 0 -30 0 0 -265z"/>
                    <path d="M640 760 l0 -220 30 0 30 0 0 220 0 220 -30 0 -30 0 0 -220z"/>
                    <path d="M920 705 l0 -165 30 0 30 0 0 165 0 165 -30 0 -30 0 0 -165z"/>
                    <path d="M1050 640 l0 -100 30 0 30 0 0 100 0 100 -30 0 -30 0 0 -100z"/>
                </g>
            </svg>
        </SvgIcon>
    )
}